<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="edit Order"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="120px"
            >
                <el-row>
                    <el-col :span="24">
                        <div class="table">
                            <el-table
                                border
                                :data="editForm.orders_goods"
                                ref="attributes"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="200"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'orders_goods.' +
                                                scope.$index +
                                                '.sku'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="SKU"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.sku"
                                                :readonly="orderType == 'custom'"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="QTY"
                                    align="center"
                                    prop="goods_num"
                                    v-if="orderType == 'edit'"
                                >
                                    <template slot-scope="scope">
                                        <el-input-number
                                            v-model="scope.row.goods_num"
                                            :min="1"
                                            size="small"
                                            :disabled="orderType == 'custom'"
                                        ></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Price"
                                    align="center"
                                    prop="goods_price"
                                    width="140"
                                    v-if="orderType == 'edit'"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Price"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.goods_price"
                                            :readonly="orderType == 'custom'"
                                        >
                                            <template slot="prepend"
                                                >$</template
                                            >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Discount"
                                    align="center"
                                    prop="goods_discount"
                                    width="140"
                                    v-if="orderType == 'edit'"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Discount"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.goods_discount"
                                            :readonly="orderType == 'custom'"
                                        >
                                            <template slot="prepend"
                                                >$</template
                                            >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="CombinationSKU"
                                    align="center"
                                    prop="is_combine_sku"
                                    width="150"
                                    v-if="orderType == 'custom'"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                        >
                                            <el-select
                                                v-model="scope.row.is_combine_sku"
                                                clearable
                                                filterable
                                                size="small"
                                                :disabled="orderType == 'custom' || orderType == 'edit'"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of combineList"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Metafileds"
                                    align="center"
                                    prop="custom_properties"
                                    v-if="orderType == 'custom'"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            readonly
                                            placeholder="Metafileds"
                                            size="small"
                                            v-model="scope.row.custom_properties"
                                            :disabled="orderType == 'edit'"
                                            @click.native="
                                                metafiledsShowDialog(
                                                    scope.$index
                                                )
                                            "
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    :key="item"
                                    width="130"
                                    v-if="orderType != 'custom'"
                                >
                                    <template slot="header" slot-scope="scope">
                                        Operation
                                        <el-button
                                            type="text"
                                            icon="el-icon-plus"
                                            @click="editItem(scope)"
                                        ></el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="removeItem(scope)"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
        <metafileds
            :metafiledsVisible.sync="metafiledsVisible"
            @saveMetafiled="saveMetafiled"
            :metafiledsLabel="metafiledsLabel"
            :is_combine="is_combine"
        ></metafileds>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import metafileds from "./metafileds";
import { mapState, mapActions } from "vuex";
export default {
    computed: {
        ...mapState({
            menu_id: (state) => state.menu.menu_id,
        }),
    },
    components: {
        metafileds,
    },
    data() {
        return {
            editForm: {
                order_id: "",
                orders_goods: [
                    {
                        id: "",
                        sku: "", //sku *
                        goods_num: "", //数量 *
                        goods_price: "", //单价 *
                        goods_discount: "", //折扣
                        custom_properties: "",
                        is_combine_sku: 2,
                    },
                ],
            },
            rules: {},
            emptyTableItem: {
                id: "",
                sku: "", //sku *
                goods_num: "", //数量 *
                goods_price: "", //单价 *
                goods_discount: "", //折扣
                custom_properties: "",
                is_combine_sku: 2,
            },
            metafiledsVisible: false,
            metafiledsLabel: "",
            is_combine: false,
            tableItemIndex: "",
            combineList:[
                {
                    label: "Yes",
                    value: 1,
                },
                {
                    label: "No",
                    value: 2,
                },
            ],
        };
    },
    methods: {
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    console.log(res);
                    // this.entityInfoData = res.data;
                    this.editForm.country =
                        this.editForm.orders_editress.country =
                            res.data.country;
                }
            });
        },
        closeDialog() {
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.editForm.orders_goods = [
                {
                    sku: "", //sku *
                    goods_num: "", //数量 *
                    goods_price: "", //单价 *
                    goods_discount: "", //折扣
                    custom_properties: "",
                    is_combine_sku: 2,
                },
            ];
            this.$emit("update:editVisible", false);
        },
        getOrdersList(page) {
            cmofferApi.orders({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    /* this.editForm.orders_goods = res.data.orders_goods;
                    this.editForm.orders_goods.forEach((item) => {
                        let custom_properties = JSON.parse(
                            JSON.stringify(item.custom_properties)
                        );
                        item.custom_properties = "";
                        // item.custom_properties = Object.entries(custom_properties).flat(Infinity).join(":");
                        Object.entries(custom_properties).forEach((sItem) => {
                            console.log(sItem);
                            item.custom_properties += sItem.join(":");
                        });
                    }); */
                    this.editForm.orders_goods = [];
                    res.data.orders_goods.forEach((item) => {
                        if (item.custom_properties && item.is_combine_sku == 2) {
                            console.log("aaa")
                            let custom_properties = JSON.parse(
                                JSON.stringify(item.custom_properties)
                            );
                            item.custom_properties = "";
                            Object.entries(custom_properties).forEach(
                                (sItem) => {
                                    //console.log("sItem: ", sItem);
                                    item.custom_properties += `${sItem[0]}: ${typeof sItem[1] == 'string' ? sItem[1] : JSON.stringify(sItem[1])}\n`;
                                }
                            );
                            this.editForm.orders_goods.push({
                                id: item.id,
                                sku: item.sku,
                                goods_num: item.goods_num,
                                goods_price: item.goods_price,
                                goods_discount: item.goods_discount,
                                custom_properties: item.custom_properties,
                                is_combine_sku: item.is_combine_sku,
                            });
                        }else if (item.combine_custom_properties && item.is_combine_sku == 1) {
                            this.editForm.orders_goods.push({
                                id: item.id,
                                sku: item.sku,
                                goods_num: item.goods_num,
                                goods_price: item.goods_price,
                                goods_discount: item.goods_discount,
                                custom_properties: JSON.stringify(item.combine_custom_properties),
                                is_combine_sku: item.is_combine_sku,
                            });
                        }
                    });
                }
            });
        },
        editItem(row) {
            this.emptyTableItem = {
                id: "",
                sku: "", //sku *
                goods_num: "", //数量 *
                goods_price: "", //单价 *
                goods_discount: "", //折扣
                custom_properties: "",
                is_combine_sku: 2,
            };
            let dataTemplate = JSON.parse(JSON.stringify(this.emptyTableItem));
            if (this.editForm.orders_goods.length == 0 || row) {
                this.editForm.orders_goods.push(dataTemplate);
            }
        },
        removeItem(scope) {
            if (this.editForm.orders_goods.length > 1) {
                for (let i in this.editForm.orders_goods) {
                    if (i == scope.$index) {
                        this.editForm.orders_goods.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    /* this.editForm.orders_goods.forEach((item) => {
                      console.log('item.custom_properties: ', item.custom_properties.split(":"));
                    }); */
                    cmofferApi
                        .orderUpdateGoods(
                            {
                                ...this.editForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                            this.closeDialog();
                            this.$parent[this.funcName]();
                        });
                }
            });
        },
        metafiledsShowDialog(i) {
            if(this.orderType == 'edit'){
                return false;
            }
            this.metafiledsVisible = true;
            this.tableItemIndex = i;
            this.metafiledsLabel = this.editForm.orders_goods[i].custom_properties;
            this.is_combine = this.editForm.orders_goods[i].is_combine_sku == 1 ? true : false;
        },
        saveMetafiled(data) {
            var properties = this.is_combine == true ? JSON.stringify(data.combine_custom_properties_new) : data.custom_properties;
            this.$set(
                this.editForm.orders_goods[this.tableItemIndex],
                "custom_properties",
                properties
            );
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
        orderType: String,
    },
    watch: {
        editVisible() {
            if (this.editVisible) {
                console.log(this.tableItem);
                this.editForm.order_id = this.tableItem.id;
                this.getOrdersList();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit {
    .container {
        ::v-deep .table {
            .el-form-item {
                margin-bottom: 0px;
            }
            .el-input-group__prepend {
                pediting: 0 10px;
            }
        }
    }
}
</style>